<input type="file" #fileInput (change)="onFileInputChange($event)" accept="video/*" capture />
<app-icon-button icon="assets/play.svg">
  <ng-content *ngIf="!isBusy && !isDirty" select="[pristine]"></ng-content>
  <ng-content *ngIf="!isBusy && isDirty" select="[dirty]"></ng-content>
  <ng-content *ngIf="isBusy" select="[busy]"></ng-content>
</app-icon-button>
